export default __webpack_public_path__ + "static/media/Partnership-Black.adc6d2ad.png";